export class BaseComponent {
  protected _isNavigationEnabled: boolean;
  protected _isCookieDisclaimerEnabled: boolean;

  public get isNavigationEnabled(): boolean {
    return this._isNavigationEnabled;
  }

  public get isCookieDisclaimerEnabled(): boolean {
    return this._isCookieDisclaimerEnabled;
  }

  constructor() {
    this._isNavigationEnabled = true;
    this._isCookieDisclaimerEnabled = true;
  }
}
